import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { ApiService } from '../api/api.service';
import { environment } from 'src/environment/environment';
import { CookieService } from 'ngx-cookie-service';


@Injectable({
  providedIn: 'root'
})
export class OtpauthService {

  private readonly COOKIE_NAME = 'loginTime';
  private readonly SESSION_DURATION = 30 * 60 * 1000;
  public readonly SECRET_DATA = 'secretData';
  public readonly OTP_ATTEMPT = 'loginAttempt';
  private readonly OPT_COUNTDOWN = 300;

  private portalId: string = environment.portalId;
  private otpAttempts: number = 0;
  public maxAttempts: number = 3;
  private otpCountdown: number = 0; 
  public showQueryButton: boolean = false;
  private countdownSubscription: Subscription | null = null;
  private countdownSubject = new BehaviorSubject<number>(this.otpCountdown);
  public countdown$ = this.countdownSubject.asObservable();

  constructor(private tostr: ToastrService, private service: ApiService, private cookieService: CookieService) {
    this.loadAttempts();
    this.loadCountdown();
   }

   getOTPAttempt(){
    const email = sessionStorage.getItem('email');
    const payload = { email: email , portalId: this.portalId };
    this.service.postRequest('',payload).subscribe(Item=>{
      if(Item.status) this.otpAttempts = Item.attempt;
      else this.otpAttempts = 0;
    })
   }

   public sendOtp(): boolean {
    if (this.otpAttempts < this.maxAttempts && this.otpCountdown <= 0) {
      this.otpAttempts++;
      localStorage.setItem('otpAttempts', this.otpAttempts.toString());
      this.otpCountdown = this.OPT_COUNTDOWN;
      localStorage.setItem('otpCountdown', this.otpCountdown.toString());
      this.startCountdown();
      return true;
    } else {
      return false;
    }
  }
  
  private startCountdown() {
    this.stopCountdown();
    this.countdownSubscription = interval(1000).pipe(
      takeWhile(() => this.otpCountdown > 0)
    ).subscribe(() => {
      this.otpCountdown--;
      localStorage.setItem('otpCountdown', this.otpCountdown.toString());
      this.countdownSubject.next(this.otpCountdown);
    }, null, () => {
      this.resetCountdown();
    });
  }

  private stopCountdown() {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
      this.countdownSubscription = null;
    }
  }

  private resetCountdown() {
    this.otpCountdown = 0;
    localStorage.removeItem('otpCountdown');    
    if(this.otpAttempts === 3) this.showQueryButton = true;
    this.resetOTP();
  }

  public resetOTP(){
    const email = sessionStorage.getItem("email");
    const payload = { email: email, portalId: this.portalId };
    this.service.postRequest(`reset-otp`,payload).subscribe(Item=>{
      console.warn(Item.message);
    });
  }

  private loadAttempts() {
    const attempts = localStorage.getItem('otpAttempts');
    if (attempts) {
      this.otpAttempts = parseInt(attempts, 10);
    }
  }

  private loadCountdown() {
    const countdown = localStorage.getItem('otpCountdown');
    if (countdown) {
      this.otpCountdown = parseInt(countdown, 10);
      this.countdownSubject.next(this.otpCountdown);
      if (this.otpCountdown > 0) {
        this.startCountdown();
      }
    }
  }

  public resetPreviousLogs(){
    this.otpCountdown = 0;
    this.otpAttempts = 0;
    localStorage.removeItem('otpAttempts');
    localStorage.removeItem('otpCountdown');
    this.countdownSubject.next(this.otpCountdown);
  }

  public resetOtpState() {    
    this.otpCountdown = 0;
    this.otpAttempts = 0;
    this.deleteCookie();
    localStorage.removeItem('otpAttempts');
    localStorage.removeItem('otpCountdown');
    this.countdownSubject.next(this.otpCountdown);
  }

  setLoginCookie() {
    const currentTime = new Date().getTime();
    this.cookieService.set(this.COOKIE_NAME, currentTime.toString(), 10);
  }

  isLoggedIn(): boolean {
    const loginTime = this.cookieService.get(this.COOKIE_NAME);
    if (!loginTime) return false;
    const timeElapsed = new Date().getTime() - parseInt(loginTime, 10);
    return timeElapsed < this.SESSION_DURATION;
  }

  deleteCookie() {
    this.cookieService.delete(this.COOKIE_NAME);
    this.cookieService.delete(this.SECRET_DATA);
    this.cookieService.delete(this.OTP_ATTEMPT);
  }
}
